(function () {
  'use strict';

  function initVariantPriceHover() {
    const variantTriggers = document.querySelectorAll('.variant-hover-trigger:not(.price-hover-initialized)');
    //console.log('Trovati', variantTriggers.length, 'nuovi trigger');

    variantTriggers.forEach(function (trigger) {
      // Marca questo elemento come già inizializzato
      trigger.classList.add('price-hover-initialized');

      const productCard = trigger.closest('product-card');
      if (!productCard) {
        //console.log('Product card non trovata per:', trigger);
        return;
      }

      const priceElement = productCard.querySelector('sale-price');
      const compareElement = productCard.querySelector('compare-at-price');

      if (!priceElement) {
        //console.log('Price element non trovato per:', trigger);
        return;
      }

      // Salva prezzi e classi originali
      const originalPrice = priceElement.innerHTML;
      const originalPriceClasses = priceElement.className;
      const originalComparePrice = compareElement ? compareElement.innerHTML : '';
      const originalCompareDisplay = compareElement ? getComputedStyle(compareElement).display : 'none';
      const originalHidden = compareElement ? compareElement.hasAttribute('hidden') : true;

      // Variabile per tracciare se un colore è stato selezionato
      let isColorSelected = false;

      //console.log('Setup completato per trigger:', trigger);

      // Gestione hover
      trigger.addEventListener('mouseenter', function () {
        if (isColorSelected) return;
        //console.log('Mouse enter su:', this);
        updatePrice(this, priceElement, compareElement);
      });

      trigger.addEventListener('mouseleave', function () {
        if (isColorSelected) return;
        //console.log('Mouse leave');
        restoreOriginalPrice(priceElement, compareElement, originalPrice, originalComparePrice, originalCompareDisplay, originalHidden, originalPriceClasses);
      });

      // Gestione click
      trigger.addEventListener('click', function (e) {
        //console.log('Click su colore:', this);

        const allTriggers = productCard.querySelectorAll('.variant-hover-trigger');
        allTriggers.forEach(function (otherTrigger) {
          otherTrigger.classList.remove('selected-color');
        });

        if (this.classList.contains('selected-color')) {
          this.classList.remove('selected-color');
          isColorSelected = false;
          restoreOriginalPrice(priceElement, compareElement, originalPrice, originalComparePrice, originalCompareDisplay, originalHidden, originalPriceClasses);
          //console.log('Colore deselezionato');
        } else {
          this.classList.add('selected-color');
          isColorSelected = true;
          updatePrice(this, priceElement, compareElement);
          //console.log('Colore selezionato, prezzo fissato');
        }
      });
    });
  }

  function updatePrice(trigger, priceElement, compareElement) {
    const variantPrice = trigger.dataset.variantPrice;
    const variantComparePrice = trigger.dataset.variantComparePrice;
    //console.log('Aggiornamento prezzo:', variantPrice);

    if (variantPrice) {
      const priceInEuro = (parseInt(variantPrice) / 100).toFixed(2);
      const formattedPrice = '€' + priceInEuro.replace('.', ',');

      const isOnSale = variantComparePrice && parseInt(variantComparePrice) > parseInt(variantPrice);

      if (isOnSale) {
        priceElement.className = 'h6 text-on-sale';
      } else {
        priceElement.className = 'h6';
      }

      priceElement.innerHTML = '<span class="sr-only">Prezzo di vendita</span>' + formattedPrice;
      //console.log('Prezzo aggiornato a:', formattedPrice, 'In saldo:', isOnSale);

      if (compareElement && isOnSale) {
        const compareInEuro = (parseInt(variantComparePrice) / 100).toFixed(2);
        const formattedComparePrice = '€' + compareInEuro.replace('.', ',');
        compareElement.innerHTML = '<span class="sr-only">Prezzo regolare</span>' + formattedComparePrice;
        compareElement.style.display = 'block';
        compareElement.removeAttribute('hidden');
      } else if (compareElement) {
        compareElement.style.display = 'none';
        compareElement.setAttribute('hidden', '');
      }
    }
  }

  function restoreOriginalPrice(priceElement, compareElement, originalPrice, originalComparePrice, originalCompareDisplay, originalHidden, originalPriceClasses) {
    priceElement.innerHTML = originalPrice;
    priceElement.className = originalPriceClasses;

    if (compareElement) {
      compareElement.innerHTML = originalComparePrice;
      compareElement.style.display = originalCompareDisplay;

      if (originalHidden) {
        compareElement.setAttribute('hidden', '');
      } else {
        compareElement.removeAttribute('hidden');
      }
    }
  }

  // Observer per contenuti caricati dinamicamente
  function setupMutationObserver() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Controlla se sono stati aggiunti nuovi nodi con variant-hover-trigger
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              // Controlla se il nodo stesso o i suoi figli contengono variant-hover-trigger
              if (node.querySelector && node.querySelector('.variant-hover-trigger:not(.price-hover-initialized)')) {
                //console.log('Nuovi elementi trovati, reinizializzo...');
                setTimeout(initVariantPriceHover, 100); // Piccolo delay per assicurarsi che il DOM sia stabile
              }
            }
          });
        }
      });
    });

    // Osserva tutto il documento per cambiamenti
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Inizializza quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantPriceHover();
      setupMutationObserver();
    });
  } else {
    initVariantPriceHover();
    setupMutationObserver();
  }
})();
